// Full-page loading spinner shown by React Suspense while a lazy-loaded page chunk
// is being downloaded. Prevents a blank white flash during navigation.
import Logo from "./Logo";

function PageLoader() {
  return (
    <div className="page-loader-full">
      <div className="loader-pulse">
        <Logo width={64} height={64} />
      </div>
    </div>
  );
}

export default PageLoader;
